import { notifyTrackingEvent } from '../../../store/to-native';
import isEqual from 'lodash.isequal';
import uniqWith from 'lodash.uniqwith';
import { WeakType } from '../../../typescript-migration';

const SEARCH_EXECUTED = 'searchExecuted';
const SCROLL_AFTER_QUERY = 'scroll';

const NATIVE_WORKOUT_SELECTED = 'WorkoutSelected';
const NATIVE_PROGRAM_SELECTED = 'ProgramSelected';
const NATIVE_BACK_CLICKED = 'BackClicked';

const GOOD_QUERY_PERFORMANCE = 'good';
const BAD_QUERY_PERFORMANCE = 'bad';

export class QueryPerformanceTracker {
  private readonly pageInteractions = [];

  public queried(filterQuery: WeakType, page: number): void {
    this.pageInteractions.push({
      data: {
        query: filterQuery.query,
        activeFilters: filterQuery,
      },
      event: page === 1 ? SEARCH_EXECUTED : SCROLL_AFTER_QUERY,
    });
  }

  public analyzeQueryPerformance = payload => {
    const interactions = this.pageInteractions;
    if (
      interactions.length > 0 &&
      [
        NATIVE_WORKOUT_SELECTED,
        NATIVE_PROGRAM_SELECTED,
        NATIVE_BACK_CLICKED,
      ].includes(payload.methodName)
    ) {
      const performanceLevel =
        (interactions.length > 0 &&
          payload.methodName === NATIVE_BACK_CLICKED) ||
        interactions.length >= 3 ||
        interactions.filter(i => i.event === SEARCH_EXECUTED).length > 1
          ? BAD_QUERY_PERFORMANCE
          : GOOD_QUERY_PERFORMANCE;

      const libraryType = payload.methodName
        .substring(0, payload.methodName.indexOf('Selected'))
        .toLowerCase();
      const queryPerformanceStats = {
        performanceLevel,
        queries: uniqWith(
          interactions.map(i => i.data.query),
          isEqual,
        ),
        pagesLoaded: interactions.length,
        interactions,
        selectedContent: libraryType
          ? {
              libraryType,
              id: payload[`${libraryType}Id`],
            }
          : null,
      };

      notifyTrackingEvent('SearchEventComplete', queryPerformanceStats);
    }
  };
}
